import { Component, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { coerceBoolean } from '@app-shared/decorators/coerce-boolean.decorator';
import { NgClassType } from '@app-type/ng-class.type';

@Component({
	selector: 'btn-load-more',
	templateUrl: './btn-load-more.component.html',
	styleUrls: ['./btn-load-more.component.scss']
})
export class BtnLoadMoreComponent {
	@Input() loading = false;
	@Input() hasMore = false;
	@coerceBoolean() @Input() outline = false;
	@coerceBoolean() @Input() transparent = false;
	@Input() color = '#145E7F';
	@Input() class: NgClassType;
	@Input() loadingPosition: 'before' | 'after' = 'before';
	@Output() loadMore = new EventEmitter<void>();

	@HostBinding('style.--btn-load-more-color')
	get btnLoadMoreColor(): string {
		return this.color || '#145E7F';
	}

	constructor() {}

	loadMoreCallback(): void {
		this.loadMore.emit();
	}
}
